import React from 'react';
import { useSelector } from 'react-redux';
import { getDatalists } from '../../features/datalist/datalist.slice';

export type DatalistProps = {
    list: string;
    name: string;
    placeholder: string;
    value?: string;
    className?: string;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onBlur: (event: React.FocusEvent<HTMLSelectElement>) => void;
} & React.ComponentPropsWithoutRef<'select'>;

export const Datalist: React.FC<DatalistProps> = ({ list, name, placeholder, value, onChange, onBlur, className, ...props }) => {
    const datalistData = useSelector(getDatalists);

    const sortedEntries: [string, string][] = datalistData.datalists?.[list]
        ? Object.entries(datalistData.datalists[list])
              .sort(([, a], [, b]) => String(a).localeCompare(String(b)))
        : [];

    return (
        <select name={name} value={value} onChange={onChange} onBlur={onBlur} className={className} {...props}>
            <option value="">{placeholder}</option>
            {sortedEntries.map(([keyName, displayValue], i) => (
                <option value={keyName} key={i}>
                    {displayValue}
                </option>
            ))}
        </select>
    );
};
